// 答案核对页面，相关路由规则

import Vue from 'vue'
import VueRouter from 'vue-router'
import routerTitle from '../plugin/routerTitle'
import routerBaiduTj from '../plugin/routerBaiduTj'
import routerPopup from '../plugin/routerPopup'
import LayoutDD from '@/pages/answer/dianDu/component/Layout'
import DianDu from '@/pages/answer/dianDu/index'
// 要告诉 vue 使用 vueRouter
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: (resolve) => require(['@/pages/answer/route/answer'], resolve),
    meta: { title: '答案核对' }
  },
  {
    path: '/listMore',
    component: (resolve) => require(['@/pages/answer/route/listMore'], resolve),
    meta: { title: '答案核对' }
  },
  {
    path: '/search',
    component: (resolve) => require(['@/pages/answer/route/search'], resolve),
    meta: { title: '搜索' }
  },
  {
    path: '/textbookDetails',
    component: () => import('@/pages/answer/route/answer/textbookDetails'),
    meta: { title: '' }
  },
  {
    path: '/answerPage',
    component: () => import('@/pages/answer/route/answer/answerPage'),
    meta: { title: '点击答案，可看讲解' }
  },

  {
    path: '/catalogue',
    component: () => import('@/pages/answer/route/answer/catalogue'),
    meta: { title: '目录' }
  },
  {
    path: '/paySuccess',
    component: () => import('@/pages/answer/route/answer/component/paySuccess'),
    meta: { title: '支付成功' }
  },
  {
    path: '/downSj',
    component: () => import('@/pages/answer/route/answer/component/downSj'),
    meta: { title: '如何下载试卷' }
  },
  // 密卷
  {
    path: '/mjBooks',
    component: () => import('@/pages/answer/mjBook/mjBooks'),
    meta: { title: '' }
  },
  {
    path: '/mjAnswerPage',
    component: () => import('@/pages/answer/mjBook/mjAnswerPage'),
    meta: { title: '点击答案，可看讲解' }
  },
  {
    path: '/mjCatalogue',
    component: () => import('@/pages/answer/mjBook/mjCatalogue'),
    meta: { title: '目录' }
  },
  {
    path: '/bookOrder',
    component: () => import('@/pages/answer/order/index'),
    meta: { title: '确认订单' }
  },
  {
    path: '/daifuDetails',
    component: () => import('@/pages/answer/order/daifuDetails'),
    meta: { title: '代付详情' }
  },

  {
    path: '/IntegralGraphic',
    component: () => import('@/pages/answer/order/IntegralGraphic'),
    meta: { title: '积分兑换' }
  },
  {
    path: '/IntegralGraphicMaintain',
    component: () => import('@/pages/answer/order/maintain'),
    meta: { title: '升级维护' }
  },

  {
    path: '/compilePhone',
    component: () => import('@/pages/answer/order/compilePhone'),
    meta: { title: '编辑信息' }
  },
  // 创建代付订单
  {
    path: '/cerateDaiFu',
    component: () => import('@/pages/answer/order/daiFuCreateOrder'),
    meta: { title: '订单详情' }
  },
  {
    path: '/rebindPhone',
    name: 'rebindPhone',
    component: () => import('@/pages/answer/order/rebindPhone'),
    meta: {
      title: '换绑手机号'
    }
  },
  {
    path: '/bookPaySuc',
    component: () => import('@/pages/answer/order/bookPaySuc'),
    meta: { title: '支付成功' }
  },
  // 点读
  {
    path: '/dianDu',
    component: LayoutDD,
    redirect: '/index',
    children: [
      {
        path: '/index',
        component: DianDu,
        meta: { title: '点读' }
      },
      {
        path: '/kbMore',
        component: () => import('@/pages/answer/dianDu/bookMore/kbMore'),
        meta: { title: '更多课本点读' }
      },
      {
        path: '/hbMore',
        component: () => import('@/pages/answer/dianDu/bookMore/hbMore'),
        meta: { title: '更多绘本点读' }
      }
    ]
  },
  {
    path: '/dianDuBooks',
    component: (resolve) => require(['@/pages/answer/dianDu/bookDetail/index'], resolve),
    meta: { title: '点读' }
  },
  {
    path: '/dianDuPage',
    component: () => import('@/pages/answer/dianDu/bookDetail/bookPage/swiperDiandu'),
    meta: { title: '点读' }
  },
  {
    path: '/dianDuPaySuccess',
    component: () => import('@/pages/answer/dianDu/bookDetail/bookPage/component/paySuccess'),
    meta: { title: '点读' }
  },
  {
    path: '/snchronousClassSuccess',
    component: () =>
      import('@/pages/answer/dianDu/bookDetail/bookPage/component/snchronousClassSuccess'),
    meta: { title: '同步视频课' }
  },
  {
    path: '/dianduAlert',
    component: () => import('@/pages/answer/dianDu/bookDetail/bookPage/component/dianduAlert'),
    meta: { title: '点读' }
  },
  {
    path: '/taskPage',
    component: () => import('@/pages/answer/route/answer/component/taskPage'),
    meta: { title: '做任务免费看答案!' }
  },
  {
    path: '/snchronousClass',
    component: () => import('@/pages/answer/dianDu/bookDetail/bookPage/component/snchronousClass'),
    meta: { title: '同步视频课' }
  },
  {
    path: '/explain',
    component: () => import('@/pages/answer/route/explain/index'),
    meta: { title: '题目讲解' }
  },
  {
    path: '/explain/comment',
    component: () => import('@/pages/answer/route/explain/jiucuo'),
    meta: { title: '题目评价' }
  },
  {
    path: '/findbook/findresult',
    component: () => import('@/pages/answer/route/findbook/findResult'),
    meta: { title: '搜索' }
  },
  {
    path: '/errorRecovery',
    component: () => import('@/pages/answer/route/active/errorRecovery.vue'),
    meta: { title: '纠错成功' }
  },
  {
    path: '/counselor',
    component: () => import('@/pages/answer/route/active/counselor.vue'),
    meta: { title: '添加老师' }
  },
  {
    path: '/mainCounselor',
    component: () => import('@/pages/answer/route/active/mainCounselor.vue'),
    meta: { title: '分配顾问' }
  },
  {
    path: '/sameQuestion',
    component: () => import('@/pages/answer/route/sameQuestion/index'),
    meta: { title: '举一反三' }
  }
]

const findBook = [
  {
    path: '/findBook/index',
    component: () => import('@/pages/answer/route/findbook/index'),
    meta: { title: '求书' }
  },
  {
    path: '/findBook/findScanQr',
    component: () => import('@/pages/answer/route/findbook/findScanQr'),
    meta: { title: '扫码求书' }
  },
  {
    path: '/findBook/findScanQr_holiday',
    component: () => import('@/pages/answer/route/findbook/findScanQr_holiday'),
    meta: { title: '扫码求书' }
  },
  {
    path: '/findBook/applyBookForm_holiday',
    component: () => import('@/pages/answer/route/findbook/applyBookForm_holiday'),
    meta: { title: '申请制作书籍' }
  },
  {
    path: '/findBook/applySuccess',
    component: () => import('@/pages/answer/route/findbook/applySuccess'),
    meta: { title: '申请成功' }
  },
  {
    path: '/findBook/overApplyNum',
    component: () => import('@/pages/answer/route/findbook/overApplyNum'),
    meta: { title: '提交结果' }
  }
]
const holiday = [
  {
    path: '/holidayBook/more',
    component: () => import('@/pages/answer/route/holidayBook/moreHolidayBook'),
    meta: { title: '更多' }
  },
  {
    path: '/holidayBook/pageNumber',
    component: () => import('@/pages/answer/route/holidayBook/pageNumber'),
    meta: { title: '假期作业' }
  },
  {
    path: '/holidayBook/answerView',
    component: () => import('@/pages/answer/route/holidayBook/answerView'),
    meta: { title: '假期作业' }
  },
  {
    path: '/holidayBook/homeWork',
    component: () => import('@/pages/answer/route/holidayBook/homeWork'),
    mate: { title: '假期作业' }
  }
]
var router = new VueRouter({
  routes: [...routes, ...holiday, ...findBook]
})
routerTitle(router)
routerBaiduTj(router)
routerPopup(router)
router.beforeEach(window.adhash)
export default router
